
import { defineComponent } from "vue";
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import StatCard from "@/components/dashboard/sequence/StatCard.vue";
import { loadPaginatedRecruitment } from "@/api/recruitments";

export default defineComponent({
  name: "recruitmenthistory",
  props: {
    widgetClasses: String,
  },
  components: {
    AgGridVue,
    StatCard,
  },
  data() {
    return {
      loading_init: true,
      gridApi: null as any,
      itemsPerPage: 100,
      to_date: new Date().toISOString().substr(0, 10),
      from_date: new Date().toISOString().substr(0, 10),
      recruitment_length: 0,
      columnDefs: [
        {
          field: "id",
          headerName: "Ref. #",
          width: 100,
          cellRenderer: (params: any) => {
            if (!params.data) return "";
            return `<div class="seq-ag-cell seq-ag-cell--muted"><span class="seq-ag-cell__primary">${params.data.id}</span></div>`;
          },
        },
        {
          field: "userFullname",
          headerName: "Fullname",
          flex: 1.5,
          minWidth: 260,
          cellRenderer: (params: any) => {
            if (!params.data) return "";
            const { usid, upref, packagestatus, userFullname } = params.data;
            return `<div class="seq-ag-cell">
              <span class="seq-ag-cell__primary">${userFullname}</span>
              <span class="seq-ag-cell__secondary">${usid} &middot; ${upref} / ${packagestatus}</span>
            </div>`;
          },
        },
        {
          field: "dteStp",
          headerName: "Date",
          flex: 1,
          minWidth: 160,
          cellRenderer: (params: any) => {
            if (!params.data) return "";
            return `<div class="seq-ag-cell seq-ag-cell--muted"><span class="seq-ag-cell__primary">${params.data.dteStp}</span></div>`;
          },
        },
        {
          field: "sponsorFullname",
          headerName: "Sponsor",
          flex: 1.5,
          minWidth: 220,
          cellRenderer: (params: any) => {
            if (!params.data) return "";
            const { sponsorFullname, spid } = params.data;
            return `<div class="seq-ag-cell">
              <span class="seq-ag-cell__primary">${sponsorFullname}</span>
              <span class="seq-ag-cell__secondary">${spid}</span>
            </div>`;
          },
        },
      ],
      defaultColDef: {
        resizable: true,
        sortable: false,
        suppressMovable: true,
        suppressCellFocus: true,
      },
    };
  },
  methods: {
    onGridReady(params: any) {
      this.gridApi = params.api;
      this.loading_init = false;

      const dataSource = {
        getRows: async (requestParams: any) => {
          try {
            const currentBlockSize = requestParams.endRow - requestParams.startRow || this.itemsPerPage || 1;
            const targetPage = Math.floor(requestParams.startRow / currentBlockSize) + 1;

            let params = {
              page: targetPage,
              f: this.from_date + " 00:00:00",
              t: this.to_date + " 23:59:59",
            };

            const response = await loadPaginatedRecruitment(params);

            const rowsThisPage = response.data.pageList || [];
            const maxServerCount = response.data.maxcount || 0;

            if (response.data.recordsPerPage && this.itemsPerPage !== response.data.recordsPerPage) {
              this.itemsPerPage = Number(response.data.recordsPerPage);
              if (this.gridApi && typeof this.gridApi.paginationSetPageSize === "function") {
                this.gridApi.paginationSetPageSize(Number(response.data.recordsPerPage));
              } else if (this.gridApi && typeof this.gridApi.setGridOption === "function") {
                this.gridApi.setGridOption("paginationPageSize", Number(response.data.recordsPerPage));
              }
            }

            this.recruitment_length = maxServerCount;
            requestParams.successCallback(rowsThisPage, maxServerCount);
          } catch (error) {
            console.error("Failed to load infinite grid data segments", error);
            requestParams.failCallback();
          }
        },
      };

      this.gridApi.setDatasource(dataSource);
    },

    recruitmentshistory() {
      if (!this.gridApi) return;
      this.gridApi.purgeInfiniteCache();
    },
  },
});
